export const BUTTON_COLORS = {
  // Primary actions
  PRIMARY: '#007bff',       // Blue for primary actions
  SUCCESS: '#28a745',       // Green for success/positive actions
  WARNING: '#ffc107',       // Yellow for warning actions
  INFO: '#17a2b8',          // Cyan for informational actions
  
  // Destructive actions
  DANGER: '#dc3545',        // Red for destructive actions (delete, logout)
  DESTRUCTIVE: '#dc3545',   // Alias for danger
  DELETE: '#dc3545',        // Alias for delete actions
  LOGOUT: '#dc3545',        // Alias for logout actions
  
  // Edit/Modify actions (green)
  EDIT: '#28a745',          // Green for edit actions
  SAVE: '#28a745',          // Green for save actions
  SUBMIT: '#28a745',        // Green for submit actions
  SEND: '#28a745',          // Green for send actions
  CREATE: '#28a745',        // Green for create actions
  
  // Moderation actions
  SANDBOX: '#fd7e14',       // Orange for sandbox/moderate actions
  MODERATE: '#fd7e14',      // Alias for moderation actions
  UNSANDBOX: '#6c757d',     // Gray for unsandbox actions
  MODERATE_BATCH: '#e6a700', // Mustard color for batch moderation actions
  USER_BULK_ACTIONS: '#e6a700', // Mustard color for user bulk actions
  
  // Neutral actions
  SECONDARY: '#6c757d',     // Gray for secondary/cancel actions
  CANCEL: '#6c757d',        // Alias for secondary/cancel
  MUTED: '#6c757d',         // Alias for muted/secondary
  REVERT: '#6c757d',        // Alias for revert actions
  CLOSE: '#6c757d',         // Alias for close actions
  
  // Special states
  DISABLED: '#6c757d',      // Gray for disabled buttons
  OUTLINE: 'transparent',   // For outline buttons
  
  // Collaboration actions
  COLLAB: '#d63384',        // Pink for collaboration actions (darker/bold, approaching purple)
  DRAFT: '#007bff',         // Blue for draft actions (alias for PRIMARY)
  
  // Weight selection colors
  WEIGHT_SUPPRESS: '#dc3545',     // Red for suppress weight (20)
  WEIGHT_SUPPRESS_SELECTED: '#b02a37', // Darker red for selected suppress
  WEIGHT_STANDARD: '#ffc107',     // Yellow for standard weight (100)
  WEIGHT_STANDARD_SELECTED: '#e0a800', // Darker yellow for selected standard
  WEIGHT_BOOST: '#28a745',        // Green for boost weight (250)
  WEIGHT_BOOST_SELECTED: '#1e7e34', // Darker green for selected boost

  // Neutral surfaces
  SURFACE_NEUTRAL: '#575b5f',          // Light grey surface background
  SURFACE_NEUTRAL_ACTIVE: '#343639',   // Slightly darker grey for active state
  SURFACE_NEUTRAL_BORDER: '#797f84',   // Border grey for neutral surfaces
};
